//=================================================================================================
// SCRIPTING
//=================================================================================================

<script>
import Vue            from 'vue';
import Component      from 'vue-class-component';
import ButtonIcon     from '@/components/ButtonIcon';
import MarkdownLoader from '@/components/MarkdownLoader';

@Component({
	// metaInfo   : function () {
	// 	return {
	// 		title : this.metaTitle || 'Loading...',
	// 	}
	// },
	components : {
		ButtonIcon,
		MarkdownLoader,
	},
	props      : {
		filename : String,
		title    : String,
		standard : String,
		buttons  : Object,
	},
})
export default class MarkdownDocument extends Vue {
	// Members
	//--------------------------------------------------------------------------------------------------

	showDetails = false; // Collapsed by default
	showIndex   = false; // Collapsed by default

	// Methods
	//--------------------------------------------------------------------------------------------------

	/**
	 * TODO
	**/
	toggleDetails () {
		this.showDetails = !this.showDetails;
		
		const spoilers = document.getElementsByClassName('spoiler');

		for (const spoiler of spoilers) {
			spoiler.classList.toggle('revealed', this.showDetails);
		}
	}

	/**
	 * TODO
	**/
	toggleIndex () {
		this.showIndex = !this.showIndex;
	}

	/**
	 * Scrolls the window position to the top of the screen.
	**/
	scrollToStart () {
		this.$router.push('');
		window.scrollTo(0, 0);
	}
}
</script>

//=================================================================================================
// TEMPLATING
//=================================================================================================

<template>
<section class="g--fullscreen g--flowdown">
	<div class="g--flow g--stretch">
		<!-- Side bar -->
		<div class="r--marginal">
			<div class="side-panel">
				<div class="s--navbar-gap" />

				<ButtonIcon
					v-if    = "!buttons || buttons['scroll']"
					:action = "scrollToStart"
					icon    = "arrow-up"
					text    = "Back to top"
				/>

				<ButtonIcon
					v-if    = "!buttons || buttons['details']"
					:action = "toggleDetails"
					:icon   = "showDetails ? 'eye' : 'eye-slash'"
					:text   = "`${ showDetails ? 'Hide' : 'Show' } all details`"
					type    = "far"
				/>

				<ButtonIcon
					:action = "toggleIndex"
					:icon   = "showIndex ? 'angle-left' : 'angle-right'"
					:text   = "`${ showIndex ? 'Hide' : 'Show' } table of contents`"
					type    = "fas"
					class   = "lg-l"
				/>
			</div>
		</div>

		<!-- Content -->
		<div class="r--content-marginless">
			<div class="s--navbar-gap" />

			<MarkdownLoader
				:filename = "filename"
				:standard = "standard"
				:class    = "{ 'table-of-content-visible' : showIndex }"
			/>
		</div>

		<div class="r--marginal" />
	</div>

	<div class="s--footer-gap" />
</section>
</template>

//=================================================================================================
// STYLING
//=================================================================================================

<style lang="scss" scoped>
.side-panel {
	z-index                     : 1001; // 1 above the navbar; to enable toolips above navbar
	display                     : flex;
	position                    : sticky;
	top                         : 0;
	margin-right                : 10px;
	flex-direction              : column;
	align-items                 : flex-end;
}
</style>
